import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";
import {
  loadOrCreateDeveloperProfile,
  regenerateDeveloperKey,
  markOnboardingComplete,
} from "../../services/dashboard.service";

export default function useDashboardData(navigate) {
  const [user, setUser] = useState(null);
  const [devData, setDevData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [onboardingDone, setOnboardingDone] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (nextUser) => {
      if (!nextUser) {
        navigate("/login");
        return;
      }

      setUser(nextUser);

      try {
        const profile = await loadOrCreateDeveloperProfile(nextUser);
        if (profile) {
          setDevData(profile);
        }
      } catch (error) {
        console.error("Profile bootstrap failed:", error);
      } finally {
        setLoading(false);
      }
    });

    return unsub;
  }, [navigate]);

  const completeOnboarding = async () => {
    setOnboardingDone(true);
    try {
      await markOnboardingComplete();
    } catch (error) {
      console.error(error);
    }
  };

  const rotateApiKey = async () => {
    const apiKey = await regenerateDeveloperKey();
    setDevData((current) => ({ ...current, apiKey }));
  };

  return {
    user,
    devData,
    loading,
    onboardingDone,
    setOnboardingDone,
    completeOnboarding,
    rotateApiKey,
  };
}
